import React, { useState } from "react";
import { ModalIn } from "./ModalIn";

export const BtnIn = ({ item, onOpenModalIn }) => {

    return (
        <a type="button" className="popover-basic" onClick={() => onOpenModalIn(item)}>
            <img src="/app-assets/images/icon-in-danh-sach.png" title="In phiếu" />
        </a>
    );
};